import { useState } from 'react'
import { useAuth } from '@/lib/auth'
import { messageErreur } from '@/lib/errors'

export default function Login() {
  const { connexion } = useAuth()
  const [email, setEmail] = useState('')
  const [mdp, setMdp] = useState('')
  const [erreur, setErreur] = useState<string | null>(null)
  const [envoi, setEnvoi] = useState(false)

  const soumettre = async (e: React.FormEvent) => {
    e.preventDefault()
    setEnvoi(true); setErreur(null)
    try { await connexion(email.trim(), mdp) }
    catch (err) {
      setErreur(/Invalid login/i.test((err as Error).message ?? '')
        ? 'Identifiants refusés.'
        : messageErreur(err))
    }
    finally { setEnvoi(false) }
  }

  return (
    <div className="login">
      <div className="card">
        <h1>FlashCP</h1>
        <p>Mêmes identifiants que SotCP — aucun compte à recréer.</p>
        <form onSubmit={(e) => void soumettre(e)}>
          <label>
            <span className="lbl">Adresse e-mail</span>
            <input className="fld" type="email" autoComplete="username" required autoFocus
                   value={email} onChange={(e) => setEmail(e.target.value)} />
          </label>
          <label>
            <span className="lbl">Mot de passe</span>
            <input className="fld" type="password" autoComplete="current-password" required
                   value={mdp} onChange={(e) => setMdp(e.target.value)} />
          </label>
          {erreur && (
            <div className="notice stop" style={{ marginTop: 4 }}>
              <span className="lamp stop" /><div className="sp">{erreur}</div>
            </div>
          )}
          <button className="btn pri" type="submit" disabled={envoi} style={{ width: '100%', marginTop: 6 }}>
            {envoi ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  )
}
